import { render } from "./PackingScreen.vue?vue&type=template&id=5b52dc33&scoped=true"
import script from "./PackingScreen.vue?vue&type=script&lang=js"
export * from "./PackingScreen.vue?vue&type=script&lang=js"

import "./PackingScreen.vue?vue&type=style&index=0&id=5b52dc33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52dc33"]])

export default __exports__